import axios from "axios";
import { localStorageItem } from '../../utils/LocalStorage'
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts'
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";
const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;
const API_LOAI_DICH_VU_QUAN_TRI_HE_THONG = API_PATH + '/obs-complex-categories/SVC';
export const getJsonGenerateForm = async (code: string) => {
    let url = API_PATH + `/term-models/${code}/model-json`;
    return axios.get(url);
};
export const createLoaiDichVuQuanTriHeThong = async (dataBody: any) => {
    return axios.post(API_LOAI_DICH_VU_QUAN_TRI_HE_THONG, dataBody);
};
export const updateLoaiDichVuQuanTriHeThong = async (id: string, dataBody: any) => {
    return axios.put(API_LOAI_DICH_VU_QUAN_TRI_HE_THONG + '/' + id, dataBody);
};
export const searchLoaiDichVuQuanTriHeThong = async (dataBody: any) => {
    return axios.get(API_LOAI_DICH_VU_QUAN_TRI_HE_THONG + '/search', dataBody);
};